"use client";

import Link from "next/link";
import PasswordResetForm from "@/components/auth/PasswordResetForm";

export function ForgotPasswordPageContent() {
  return (
    <main className="min-h-screen flex items-center justify-center p-4 sm:p-8 bg-muted">
      <div className="max-w-md w-full">
        <div className="text-center mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-primary">
            Forgot your password?
          </h1>
        </div>

        <PasswordResetForm
          onSuccess={() => {
            // Success message is handled by PasswordResetForm
          }}
          onCancel={() => {
            window.location.href = "/login";
          }}
        />

        <div className="mt-4 text-center">
          <Link
            href="/login"
            className="text-sm text-info hover:text-info transition-colors duration-200"
          >
            Back to sign in
          </Link>
        </div>
      </div>
    </main>
  );
}

export function ForgotPasswordPageFallback() {
  return (
    <main className="min-h-screen flex items-center justify-center p-4 sm:p-8 bg-muted">
      <div className="max-w-md w-full">
        <div className="text-center mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-primary">
            Forgot your password?
          </h1>
        </div>
        <div className="bg-card border border-border rounded-lg p-6 sm:p-8 shadow-sm">
          <div className="animate-pulse">
            <div className="h-4 bg-muted rounded mb-4"></div>
            <div className="h-4 bg-muted rounded mb-4"></div>
            <div className="h-8 bg-muted rounded"></div>
          </div>
        </div>
      </div>
    </main>
  );
}
